import {Component, OnInit} from "@angular/core";
import {UtilsService} from "../../../core/utils/utils.service";
import {Subscription} from "rxjs";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {FormControl, FormGroup} from "@angular/forms";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {ToastService} from "../../../core/services/technique/toast.service";
import {ConviveDTO} from "../../../core/dtos/convive-dto";
import {ConvivesService} from "../../../core/services/entities/convives.service";

@Component({
  selector: 'yo-convive-edition-dialog',
  templateUrl: './convive-edition-dialog.component.html',
  styleUrls: ['./convive-edition-dialog.component.scss']
})
export class ConviveEditionDialogComponent implements OnInit {

  convive: ConviveDTO;

  dialogTitle: string;

  subOpenDialog: Subscription;

  displayDialog: boolean = false;

  sitePlaceholder: string;

  idSelectedSite: number;

  form: FormGroup;

  constructor(private utilsSvc: UtilsService,
              private conviveSvc: ConvivesService,
              private i8nSvc: InternationalizationService,
              private auth2Svc: Auth2Service,
              private toastSvc: ToastService) {
  }

  ngOnInit() {
    this.initForm();
    this.openDialogEditionSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
  }

  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.conviveSvc.openDialogEdition$
      .subscribe((c: ConviveDTO) => {
        this.displayDialog = true;
        if (!c) {
          this.convive = new ConviveDTO();
          this.dialogTitle = this.i8nSvc.getLabelFromCode("TITLE_CREATION_CONVIVE", null);
        } else {
          this.convive = c;
          this.dialogTitle = this.i8nSvc.getLabelFromCode("TITLE_MODIFICATION_CONVIVE", null);
        }
        this.initForm();
      });
  };

  initForm = (): void => {
    this.sitePlaceholder = !this.canModify() ? this.convive?.site?.libelle : 'Selectionner le site...';
    this.idSelectedSite = this.convive?.site?.id;
    this.form = new FormGroup({
      libelle: new FormControl(this.convive?.libelle),
      actif: new FormControl(this.convive?.actif != null ? this.convive?.actif : true)
    });
  };

  onChangeSite = ($event: any): void => {
    this.idSelectedSite = $event.selectedItem?.id;
  }

  canModify = () => {
    return this.conviveSvc.canModify(this.convive);
  }

  save = (): void => {
    if (this.form.valid) {
      let item: ConviveDTO = {...this.convive };
      item.site = {id: this.idSelectedSite } as SiteDTO;
      item.libelle = this.form.controls['libelle'].value;
      item.actif = this.form.controls['actif'].value;
      this.conviveSvc.save(item)
        .subscribe(response => {
          this.conviveSvc.announceConviveSaved();
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde de la prestation réalisée avec succès`);
          this.closeDialog();
        });
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  }

  findAllLocalSites = (): SiteDTO[] => {
    return this.auth2Svc.utilisateur.siteListLocaux;
  }

  closeDialog = (): void => {
    this.displayDialog = false;
  };

}
